import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";

import { ShippingBoxSecure } from "@/assets/icons/24/ShippingBoxSecure";
import { ProductDeliveryOptionItemProps } from "@/features/product-delivery-options/components/ProductDeliveryOptionItem";
import { ProductDeliveryOptionItemRow } from "@/features/product-delivery-options/components/ProductDeliveryOptionItemRow";
import { getProductDeliveryPriceLabel } from "@/features/product-delivery-options/components/utils/product-delivery-options.utils";
import { useProductDeliveryEstimateLabel } from "@/features/product-delivery-options/hooks/useProductDeliveryEstimateLabel";

export const ProductDeliveryOptionItemPostal = ({
  option,
  loading,
}: ProductDeliveryOptionItemProps) => {
  const { t } = useTranslation();
  const { locale } = useRouter();

  const estimate = useProductDeliveryEstimateLabel(option);
  const { label, isFree } = getProductDeliveryPriceLabel(option, t, locale);

  return (
    <ProductDeliveryOptionItemRow
      method="postal-wuunder"
      icon={<ShippingBoxSecure className="size-6 shrink-0 text-brand-500" />}
      title={t("pdp:pdp-usp-shipping-title-postal")}
      subtitle={estimate}
      priceLabel={label}
      isFree={isFree}
      loading={loading}
    />
  );
};
